import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { fetchAssetPriceData } from './services/dataService';
import { DATA_CONFIG } from './config/dataConfig';

// ============================================================================
// ASSET REGISTRY - Easy to extend with new assets
// ============================================================================
const ASSET_REGISTRY = {
  bitcoin: {
    id: 'bitcoin',
    name: 'Bitcoin',
    symbol: 'BTC',
    unit: 'BTC',
    currency: 'USD',
    color: '#F7931A',
    emoji: '₿',
    logoUrl: 'https://cryptologos.cc/logos/bitcoin-btc-logo.png',
    sheetName: 'Bitcoin', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/bitcoin/market_chart'
    }
  },
  ethereum: {
    id: 'ethereum',
    name: 'Ethereum',
    symbol: 'ETH',
    unit: 'ETH',
    currency: 'USD',
    color: '#627EEA',
    emoji: 'Ξ',
    logoUrl: 'https://cryptologos.cc/logos/ethereum-eth-logo.png',
    sheetName: 'Ethereum', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/ethereum/market_chart'
    }
  },
  sui: {
    id: 'sui',
    name: 'Sui',
    symbol: 'SUI',
    unit: 'SUI',
    currency: 'USD',
    color: '#4DA2FF',
    emoji: '🌊',
    logoUrl: 'https://cryptologos.cc/logos/sui-sui-logo.png',
    sheetName: 'Sui', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/sui/market_chart'
    }
  },
  solana: {
    id: 'solana',
    name: 'Solana',
    symbol: 'SOL',
    unit: 'SOL',
    currency: 'USD',
    color: '#14F195',
    emoji: '◎',
    logoUrl: 'https://cryptologos.cc/logos/solana-sol-logo.png',
    sheetName: 'Solana', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/solana/market_chart'
    }
  },
  bnb: {
    id: 'bnb',
    name: 'BNB',
    symbol: 'BNB',
    unit: 'BNB',
    currency: 'USD',
    color: '#F3BA2F',
    emoji: '🔶',
    logoUrl: 'https://cryptologos.cc/logos/bnb-bnb-logo.png',
    sheetName: 'BNB', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/bnb/market_chart'
    }
  },
  avax: {
    id: 'avax',
    name: 'Avalanche',
    symbol: 'AVAX',
    unit: 'AVAX',
    currency: 'USD',
    color: '#E84142',
    emoji: '🔺',
    logoUrl: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    sheetName: 'Avax', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/avalanche-2/market_chart'
    }
  },
  doge: {
    id: 'doge',
    name: 'Dogecoin',
    symbol: 'DOGE',
    unit: 'DOGE',
    currency: 'USD',
    color: '#C2A633',
    emoji: '🐕',
    logoUrl: 'https://cryptologos.cc/logos/dogecoin-doge-logo.png',
    sheetName: 'Doge', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/dogecoin/market_chart'
    }
  },
  aptos: {
    id: 'aptos',
    name: 'Aptos',
    symbol: 'APT',
    unit: 'APT',
    currency: 'USD',
    color: '#00D4AA',
    emoji: '🅰️',
    logoUrl: 'https://cryptologos.cc/logos/aptos-apt-logo.png',
    sheetName: 'Aptos', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/aptos/market_chart'
    }
  },
  cardano: {
    id: 'cardano',
    name: 'Cardano',
    symbol: 'ADA',
    unit: 'ADA',
    currency: 'USD',
    color: '#0033AD',
    emoji: '₳',
    logoUrl: 'https://cryptologos.cc/logos/cardano-ada-logo.png',
    sheetName: 'Cardano', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/cardano/market_chart'
    }
  },
  trx: {
    id: 'trx',
    name: 'Tron',
    symbol: 'TRX',
    unit: 'TRX',
    currency: 'USD',
    color: '#FF060A',
    emoji: '⚡',
    logoUrl: 'https://cryptologos.cc/logos/tron-trx-logo.png',
    sheetName: 'Trx', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/tron/market_chart'
    }
  },
  zcash: {
    id: 'zcash',
    name: 'Zcash',
    symbol: 'ZEC',
    unit: 'ZEC',
    currency: 'USD',
    color: '#F4B728',
    emoji: '🛡️',
    logoUrl: 'https://cryptologos.cc/logos/zcash-zec-logo.png',
    sheetName: 'Zcash', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/zcash/market_chart'
    }
  },
    walrus: {
      id: 'walrus',
      name: 'Walrus',
      symbol: 'WAL',
      unit: 'WAL',
      currency: 'USD',
      color: '#F4B728',
      emoji: '🛡️',
      logoUrl: 'https://assets.coingecko.com/coins/images/54914/standard/WAL_logo.png?1742494301',
      sheetName: 'Walrus', // Google Sheets sheet name
      apiConfig: {
        type: 'coingecko',
        endpoint: 'https://api.coingecko.com/api/v3/coins/walrus-2/market_chart'
      }
    },
  coin98: {
    id: 'coin98',
    name: 'Coin98',
    symbol: 'C98',
    unit: 'C98',
    currency: 'USD',
    color: '#e0bf55',
    emoji: '🛡️',
    logoUrl: 'https://assets.coingecko.com/coins/images/17117/standard/logo.png?1696516677',
    sheetName: 'Coin98', // Google Sheets sheet name
    apiConfig: {
      type: 'coingecko',
      endpoint: 'https://api.coingecko.com/api/v3/coins/coin98/market_chart'
    }
  }

};

// ============================================================================
// NOTE: Historical data and API fetching now handled by service layer
// See: src/services/dataService.js
// ============================================================================

// ============================================================================
// RESPONSIVE HOOK - Breakpoint detection for mobile/tablet/desktop
// ============================================================================
const useResponsive = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobileSmall: windowWidth <= 480,
    isMobile: windowWidth <= 768,
    isTablet: windowWidth > 768 && windowWidth <= 1024,
    isDesktop: windowWidth > 1024,
    width: windowWidth
  };
};

// ============================================================================
// CALCULATION ENGINE
// ============================================================================
const calculateInvestment = (assetId, dailyAmount, startDate, endDate, priceData, useCurrentPrice = false, currentPrice = null) => {
  let totalInvested = 0;
  let totalAssetQuantity = 0;
  const timeline = [];

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Create a price map for quick lookup
  const priceMap = {};
  priceData.forEach(item => {
    priceMap[item.date] = item.price;
  });

  let currentDate = new Date(start);

  while (currentDate <= end) {
    const dateStr = currentDate.toISOString().split('T')[0];
    const price = priceMap[dateStr];

    if (price) {
      // Buy assets with daily amount
      const quantityBought = dailyAmount / price;
      totalAssetQuantity += quantityBought;
      totalInvested += dailyAmount;

      // Calculate current value
      const currentValue = totalAssetQuantity * price;

      timeline.push({
        date: dateStr,
        assetQuantity: totalAssetQuantity,
        value: currentValue,
        invested: totalInvested
      });
    }

    currentDate.setDate(currentDate.getDate() + 1);
  }

  // Final calculations
  let finalPrice;
  let comparisonDate;

  console.log('[Toggle Debug] useCurrentPrice:', useCurrentPrice);
  console.log('[Toggle Debug] currentPrice param:', currentPrice);

  if (useCurrentPrice && currentPrice) {
    // Use current price (today)
    finalPrice = currentPrice;
    comparisonDate = new Date().toISOString().split('T')[0];
    console.log('[Toggle Debug] Using CURRENT price:', finalPrice);
  } else {
    // Use end date price
    finalPrice = priceMap[end.toISOString().split('T')[0]] || priceData[priceData.length - 1].price;
    comparisonDate = end.toISOString().split('T')[0];
    console.log('[Toggle Debug] Using END DATE price:', finalPrice);
  }

  const currentValue = totalAssetQuantity * finalPrice;
  const roi = ((currentValue - totalInvested) / totalInvested) * 100;

  console.log('[Toggle Debug] Final calculation:', {
    totalAssetQuantity,
    finalPrice,
    currentValue,
    roi,
    comparisonMode: useCurrentPrice ? 'current' : 'endDate'
  });

  return {
    totalInvested,
    totalAssetQuantity,
    currentValue,
    roi,
    timeline,
    comparisonMode: useCurrentPrice ? 'current' : 'endDate',
    comparisonDate,
    finalPrice
  };
};

// ============================================================================
// MAIN COMPONENT
// ============================================================================
const WhatIfInvested = () => {
  // Responsive breakpoints
  const { isMobile, isMobileSmall } = useResponsive();

  const [selectedAsset, setSelectedAsset] = useState('bitcoin');
  const [dailyAmount, setDailyAmount] = useState(10);
  const [startDate, setStartDate] = useState('2023-01-01');
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasCalculated, setHasCalculated] = useState(false);
  const [isStale, setIsStale] = useState(false);
  const [useCurrentPrice, setUseCurrentPrice] = useState(false);
  const [useTodayDate, setUseTodayDate] = useState(true); // TODAY checkbox default checked

  // Fetch current price for comparison
  const fetchCurrentPrice = async (assetId) => {
    console.log('[Toggle Debug] Fetching current price for:', assetId);
    const config = DATA_CONFIG.apis[assetId];
    console.log('[Toggle Debug] API Config:', config);

    if (config.provider === 'coingecko') {
      // Extract coin ID from endpoint (e.g., '/coins/bitcoin/market_chart' -> 'bitcoin')
      const coinId = config.endpoint.split('/')[2];
      const url = `https://api.coingecko.com/api/v3/simple/price?ids=${coinId}&vs_currencies=usd`;
      console.log('[Toggle Debug] Coin ID:', coinId);
      console.log('[Toggle Debug] Fetching from URL:', url);

      try {
        const response = await fetch(url);
        const data = await response.json();
        console.log('[Toggle Debug] API Response:', data);

        const price = data[coinId]?.usd;
        console.log('[Toggle Debug] Current price:', price);
        return price || null;
      } catch (error) {
        console.error('[Toggle Debug] Error fetching current price:', error);
        return null;
      }
    }

    // For other sources, return null (will use end date price)
    console.warn(`Current price fetch not supported for ${assetId}`);
    return null;
  };

  const calculateResults = async () => {
    setLoading(true);

    try {
      // Fetch combined price data from Google Sheets + API
      const allPriceData = await fetchAssetPriceData(selectedAsset, startDate, endDate);

      if (allPriceData.length === 0) {
        console.warn('No price data available for the selected date range');
        setResults(null);
        setLoading(false);
        return;
      }

      // Fetch current price if toggle is ON
      let currentPrice = null;
      if (useCurrentPrice) {
        currentPrice = await fetchCurrentPrice(selectedAsset);
      }

      // Calculate investment results
      const calculationResults = calculateInvestment(
        selectedAsset,
        dailyAmount,
        startDate,
        endDate,
        allPriceData,
        useCurrentPrice,
        currentPrice
      );

      setResults(calculationResults);
      setHasCalculated(true);
      setIsStale(false);
    } catch (error) {
      console.error('Calculation error:', error);
      alert('Error fetching price data. Please check console for details.');
    }

    setLoading(false);
  };


  const asset = ASSET_REGISTRY[selectedAsset];

  return (
    <div className="app-container" style={{
      minHeight: '100vh',
      background: '#58CC02',
      padding: isMobile ? '20px 12px' : '40px 20px',
      fontFamily: '"DIN Round", "Nunito", -apple-system, BlinkMacSystemFont, sans-serif'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Header */}
        <div className="header-section" style={{
          textAlign: 'center',
          marginBottom: isMobile ? '32px' : '48px'
        }}>
          <div className="title-container" style={{
            display: 'inline-block',
            background: '#fff',
            padding: isMobile ? '16px 24px' : '20px 40px',
            borderRadius: isMobile ? '16px' : '24px',
            marginBottom: isMobile ? '16px' : '24px',
            boxShadow: '0 8px 0 rgba(0, 0, 0, 0.1)',
            border: '3px solid #fff'
          }}>
            <h1 className="main-title" style={{
              fontSize: isMobileSmall ? '32px' : isMobile ? '36px' : '48px',
              fontWeight: '900',
              color: '#58CC02',
              margin: 0,
              letterSpacing: '-1px'
            }}>
            🤔 What If I Had Invested...
            </h1>
          </div>
          <p className="subtitle" style={{
            fontSize: isMobile ? '16px' : '22px',
            color: '#fff',
            fontWeight: '700',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
          }}>
            See how much you could have earned! 🤑
          </p>
        </div>

        {/* Input Section */}
        <div className="input-section" style={{
          background: '#fff',
          borderRadius: isMobile ? '24px' : '32px',
          padding: isMobile ? '24px 20px' : '40px',
          marginBottom: isMobile ? '24px' : '32px',
          boxShadow: '0 12px 0 rgba(0, 0, 0, 0.1)',
          border: '4px solid #fff'
        }}>
          <div className="input-grid" style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '2fr 1.5fr 1.5fr 1.5fr',
            gap: isMobile ? '16px' : '20px',
            alignItems: 'start'
          }}>
            {/* Asset Selection */}
            <div>
              <label style={{
                display: 'block',
                color: '#4B4B4B',
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: '800',
                marginBottom: '12px'
              }}>
                🏆 Choose Your Asset
              </label>
              <select
                value={selectedAsset}
                onChange={(e) => {
                  setSelectedAsset(e.target.value);
                  if (hasCalculated) setIsStale(true);
                }}
                style={{
                  width: '100%',
                  padding: isMobile ? '14px' : '16px',
                  paddingRight: '40px',
                  background: '#F7F7F7',
                  border: '3px solid #E5E5E5',
                  borderRadius: '16px',
                  color: '#4B4B4B',
                  fontSize: isMobile ? '15px' : '16px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  outline: 'none',
                  transition: 'all 0.2s',
                  appearance: 'none',
                  backgroundImage: 'url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%234B4B4B\' stroke-width=\'3\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e")',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right 12px center',
                  backgroundSize: '20px'
                }}
              >
                {Object.values(ASSET_REGISTRY).map(asset => (
                  <option key={asset.id} value={asset.id}>
                    {asset.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Daily Amount */}
            <div style={{ position: 'relative' }}>
              <label style={{
                display: 'block',
                color: '#4B4B4B',
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: '800',
                marginBottom: '12px'
              }}>
                💵 Daily Invest
              </label>
              <div style={{ position: 'relative' }}>
                <span style={{
                  position: 'absolute',
                  left: '16px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#4B4B4B',
                  fontSize: isMobile ? '15px' : '16px',
                  fontWeight: '700',
                  pointerEvents: 'none'
                }}>$</span>
                <input
                  type="number"
                  value={dailyAmount}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow empty string for deletion, otherwise convert to number
                    setDailyAmount(value === '' ? '' : Number(value));
                    if (hasCalculated) setIsStale(true);
                  }}
                  onBlur={(e) => {
                    // Reset to 1 if left empty when user leaves the field
                    if (e.target.value === '' || Number(e.target.value) < 1) {
                      setDailyAmount(1);
                    }
                  }}
                  min="1"
                  style={{
                    width: '100%',
                    padding: isMobile ? '14px 14px 14px 28px' : '16px 16px 16px 32px',
                    background: '#F7F7F7',
                    border: '3px solid #E5E5E5',
                    borderRadius: '16px',
                    color: '#4B4B4B',
                    fontSize: isMobile ? '15px' : '16px',
                    fontWeight: '700',
                    outline: 'none'
                  }}
                />
              </div>
            </div>

            {/* Start Date */}
            <div>
              <label style={{
                display: 'block',
                color: '#4B4B4B',
                fontSize: isMobile ? '20px' : '18px',
                fontWeight: '800',
                marginBottom: '12px'
              }}>
                📅 Start Date
              </label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  if (hasCalculated) setIsStale(true);
                }}
                max={endDate}
                style={{
                  width: isMobile ? '100%' : '100%',
                  padding: isMobile ? '12px 8px' : '16px',
                  background: '#F7F7F7',
                  border: '3px solid #E5E5E5',
                  borderRadius: '16px',
                  color: '#4B4B4B',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '700',
                  outline: 'none'
                }}
              />
            </div>

            {/* End Date */}
            <div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '12px'
              }}>
                <label style={{
                  color: '#4B4B4B',
                  fontSize: isMobile ? '16px' : '18px',
                  fontWeight: '800'
                }}>
                  🏁 End Date
                </label>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <label
                    htmlFor="todayCheckbox"
                    style={{
                      fontSize: isMobile ? '13px' : '14px',
                      fontWeight: '700',
                      color: '#4B4B4B',
                      cursor: 'pointer',
                      userSelect: 'none',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    TODAY
                  </label>
                  <input
                    type="checkbox"
                    id="todayCheckbox"
                    checked={useTodayDate}
                    onChange={(e) => {
                      setUseTodayDate(e.target.checked);
                      if (e.target.checked) {
                        setEndDate(new Date().toISOString().split('T')[0]);
                      }
                      if (hasCalculated) setIsStale(true);
                    }}
                    style={{
                      width: '20px',
                      height: '20px',
                      cursor: 'pointer',
                      accentColor: '#58CC02'
                    }}
                  />
                </div>
              </div>
              <input
                type="date"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                  if (hasCalculated) setIsStale(true);
                }}
                disabled={useTodayDate}
                min={startDate}
                max={new Date().toISOString().split('T')[0]}
                style={{
                  width: isMobile ? '100%' : '100%',
                  padding: isMobile ? '12px 8px' : '16px',
                  background: '#F7F7F7',
                  border: '3px solid #E5E5E5',
                  borderRadius: '16px',
                  color: '#4B4B4B',
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '700',
                  outline: 'none',
                  opacity: useTodayDate ? 0.5 : 1,
                  cursor: useTodayDate ? 'not-allowed' : 'pointer'
                }}
              />
            </div>
          </div>

          {/* Compare with Current Price Toggle */}
          <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'flex-start' : 'center',
            gap: isMobile ? '12px' : '16px',
            padding: isMobile ? '16px 0' : '20px 0',
            marginTop: '8px'
          }}>
            {/* Toggle Switch */}
            <div
              onClick={() => {
                setUseCurrentPrice(!useCurrentPrice);
                if (hasCalculated) setIsStale(true);
              }}
              style={{
                position: 'relative',
                width: '50px',
                height: '20px',
                backgroundColor: useCurrentPrice ? '#58CC02' : '#E5E5E5',
                borderRadius: '13px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                border: '1px solid ' + (useCurrentPrice ? '#58CC02' : '#E5E5E5')
              }}
            >
              <div style={{
                position: 'relative',
                top: '0px',
                left: useCurrentPrice ? '30px' : '1px',
                width: '18px',
                height: '18px',
                backgroundColor: '#fff',
                borderRadius: '50%',
                transition: 'left 0.3s ease',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }} />
            </div>

            {/* Label */}
            <label
              onClick={() => {
                setUseCurrentPrice(!useCurrentPrice);
                if (hasCalculated) setIsStale(true);
              }}
              style={{
                color: useCurrentPrice ? '#4B4B4B' : '#AFAFAF',
                fontSize: isMobile ? '15px' : '16px',
                fontWeight: '700',
                cursor: 'pointer',
                userSelect: 'none',
                transition: 'color 0.3s ease'
              }}
            >
              📊 Compare with Current Price (Today)
            </label>
          </div>

          {/* Calculate Button */}
          <button
            onClick={calculateResults}
            disabled={loading}
            style={{
              marginTop: isMobile ? '24px' : '32px',
              width: '100%',
              padding: isMobile ? '16px' : '20px',
              background: loading ? '#E5E5E5' : '#58CC02',
              border: 'none',
              borderRadius: '16px',
              borderBottom: loading ? '4px solid #C0C0C0' : '4px solid #4CAF00',
              color: '#fff',
              fontSize: isMobile ? '16px' : '20px',
              fontWeight: '900',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.15s',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              position: 'relative',
              top: 0
            }}
            onMouseDown={(e) => {
              if (!loading) {
                e.target.style.top = '4px';
                e.target.style.borderBottom = '0px solid #4CAF00';
              }
            }}
            onMouseUp={(e) => {
              if (!loading) {
                e.target.style.top = '0px';
                e.target.style.borderBottom = '4px solid #4CAF00';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.top = '0px';
                e.target.style.borderBottom = '4px solid #4CAF00';
              }
            }}
          >
            {loading ? '⏳ Calculating...' : '✨ Calculate My Returns!'}
          </button>
        </div>

        {/* Results Section */}
        {!hasCalculated ? (
          /* Empty State - No calculation yet */
          <div style={{
            background: '#fff',
            borderRadius: isMobile ? '24px' : '32px',
            padding: isMobile ? '60px 24px' : '80px 40px',
            marginBottom: isMobile ? '24px' : '32px',
            boxShadow: '0 12px 0 rgba(0, 0, 0, 0.1)',
            border: '4px solid #fff',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: isMobile ? '60px' : '80px', marginBottom: isMobile ? '20px' : '24px' }}>📊</div>
            <h2 style={{
              fontSize: isMobile ? '24px' : '32px',
              fontWeight: '900',
              color: '#4B4B4B',
              marginBottom: '16px'
            }}>
              Ready to see your potential returns?
            </h2>
            <p style={{
              fontSize: isMobile ? '15px' : '18px',
              color: '#AFAFAF',
              fontWeight: '700',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Choose your asset, set your daily investment amount and date range, then click <strong style={{ color: '#58CC02' }}>"Calculate My Returns!"</strong> to see how much you could have earned! 🚀
            </p>
          </div>
        ) : (
          <>
            {/* Stats Cards */}
            <div className="stats-grid" style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: isMobile ? '16px' : '20px',
              marginBottom: isMobile ? '24px' : '32px'
            }}>
              {/* Total Invested */}
              <div style={{
                background: '#fff',
                borderRadius: isMobile ? '20px' : '24px',
                padding: isMobile ? '24px' : '28px',
                boxShadow: '0 8px 0 rgba(0, 0, 0, 0.1)',
                border: '4px solid #fff',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                  fontSize: isMobile ? '60px' : '80px',
                  opacity: '0.1'
                }}>💸</div>
                <div style={{
                  fontSize: isMobile ? '14px' : '16px',
                  color: '#AFAFAF',
                  fontWeight: '800',
                  marginBottom: '8px'
                }}>
                  Total Invested
                </div>
                <div style={{
                  fontSize: isMobile ? '28px' : '32px',
                  fontWeight: '900',
                  color: '#4B4B4B',
                  marginBottom: '4px'
                }}>
                  {isStale ? (
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '60px', marginBottom: '8px' }}>🤔</div>
                      <div style={{ fontSize: '14px', color: '#AFAFAF', fontWeight: '700' }}>
                        Waiting for calculation...
                      </div>
                    </div>
                  ) : (
                    `$${results.totalInvested.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                  )}
                </div>
              </div>

              {/* Asset Quantity */}
              <div style={{
                background: '#fff',
                borderRadius: isMobile ? '20px' : '24px',
                padding: isMobile ? '24px' : '28px',
                boxShadow: '0 8px 0 rgba(0, 0, 0, 0.1)',
                border: '4px solid #fff',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                  width: isMobile ? '60px' : '80px',
                  height: isMobile ? '60px' : '80px',
                  opacity: '0.15',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {asset.logoUrl ? (
                    <img
                      src={asset.logoUrl}
                      alt={asset.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = `<div style="font-size: 80px; opacity: 1">${asset.emoji || '💰'}</div>`;
                      }}
                    />
                  ) : (
                    <div style={{ fontSize: '80px', opacity: '1' }}>
                      {asset.emoji || '💰'}
                    </div>
                  )}
                </div>
                <div style={{
                  fontSize: isMobile ? '14px' : '16px',
                  color: '#AFAFAF',
                  fontWeight: '800',
                  marginBottom: '8px'
                }}>
                  {asset.name} Acquired
                </div>
                <div style={{
                  fontSize: isMobile ? '28px' : '32px',
                  fontWeight: '900',
                  color: asset.color,
                  marginBottom: '4px'
                }}>
                  {isStale ? (
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: isMobile ? '50px' : '60px' }}>💭</div>
                    </div>
                  ) : (
                    results.totalAssetQuantity.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 })
                  )}
                </div>
                <div style={{
                  fontSize: isMobile ? '13px' : '14px',
                  color: '#AFAFAF',
                  fontWeight: '700'
                }}>
                  {asset.unit}
                </div>
              </div>

              {/* Current Value */}
              <div style={{
                background: '#fff',
                borderRadius: isMobile ? '20px' : '24px',
                padding: isMobile ? '24px' : '28px',
                boxShadow: '0 8px 0 rgba(0, 0, 0, 0.1)',
                border: '4px solid #fff',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                  fontSize: isMobile ? '60px' : '80px',
                  opacity: '0.1'
                }}>💎</div>
                <div style={{
                  fontSize: isMobile ? '14px' : '16px',
                  color: '#AFAFAF',
                  fontWeight: '800',
                  marginBottom: '8px'
                }}>
                  Current Value
                </div>
                <div style={{
                  fontSize: isMobile ? '28px' : '32px',
                  fontWeight: '900',
                  color: '#58CC02',
                  marginBottom: '4px'
                }}>
                  {isStale ? (
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: isMobile ? '50px' : '60px' }}>⏳</div>
                    </div>
                  ) : (
                    `$${results.currentValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                  )}
                </div>
                {!isStale && results.comparisonDate && (
                  <div style={{
                    fontSize: isMobile ? '11px' : '12px',
                    color: '#AFAFAF',
                    fontWeight: '700',
                    marginTop: '8px'
                  }}>
                    {results.comparisonMode === 'current'
                      ? `📅 As of Today (${results.comparisonDate})`
                      : `📅 As of ${results.comparisonDate}`}
                  </div>
                )}
              </div>

              {/* ROI */}
              <div style={{
                background: results.roi >= 0 ? '#58CC02' : '#FF4B4B',
                borderRadius: isMobile ? '20px' : '24px',
                padding: isMobile ? '24px' : '28px',
                boxShadow: results.roi >= 0 ? '0 8px 0 #4CAF00' : '0 8px 0 #CC0000',
                border: '4px solid #fff',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: '-10px',
                  right: '-10px',
                  fontSize: isMobile ? '60px' : '80px',
                  opacity: '0.2'
                }}>{results.roi >= 0 ? '🎉' : '📉'}</div>
                <div style={{
                  fontSize: isMobile ? '14px' : '16px',
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontWeight: '800',
                  marginBottom: '8px'
                }}>
                  Return on Investment
                </div>
                <div style={{
                  fontSize: isMobile ? '36px' : '42px',
                  fontWeight: '900',
                  color: '#fff',
                  marginBottom: '4px'
                }}>
                  {isStale ? (
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: isMobile ? '50px' : '60px' }}>🔄</div>
                    </div>
                  ) : (
                    `${results.roi >= 0 ? '+' : ''}${results.roi.toFixed(2)}%`
                  )}
                </div>
                <div style={{
                  fontSize: isMobile ? '15px' : '18px',
                  color: 'rgba(255, 255, 255, 0.9)',
                  fontWeight: '800'
                }}>
                  {isStale ? 'Recalculate needed' : `${results.roi >= 0 ? '↗' : '↘'} $${Math.abs(results.currentValue - results.totalInvested).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                </div>
              </div>
            </div>

            {/* Chart Section */}
            <div style={{
              background: '#fff',
              borderRadius: isMobile ? '24px' : '32px',
              padding: isMobile ? '24px 16px' : '40px',
              boxShadow: '0 12px 0 rgba(0, 0, 0, 0.1)',
              border: '4px solid #fff'
            }}>
              <h2 style={{
                fontSize: isMobile ? '22px' : '28px',
                fontWeight: '900',
                color: '#4B4B4B',
                marginBottom: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: isMobile ? '8px' : '12px'
              }}>
                📈 Your Investment Journey
              </h2>
              <p style={{
                fontSize: isMobile ? '14px' : '16px',
                color: '#AFAFAF',
                fontWeight: '700',
                marginBottom: isMobile ? '20px' : '28px'
              }}>
                Watch your money grow over time!
              </p>

              {isStale ? (
                <div style={{
                  height: isMobile ? 300 : 400,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  gap: '20px'
                }}>
                  <div style={{ fontSize: isMobile ? '60px' : '80px' }}>📊</div>
                  <h3 style={{ color: '#4B4B4B', fontSize: isMobile ? '20px' : '24px', fontWeight: '900' }}>
                    Your settings have changed!
                  </h3>
                  <p style={{ color: '#AFAFAF', fontSize: isMobile ? '14px' : '16px', fontWeight: '700' }}>
                    Click <strong style={{ color: '#58CC02' }}>"Calculate My Returns!"</strong> to see updated results
                  </p>
                </div>
              ) : (
                <ResponsiveContainer width="100%" height={isMobile ? 300 : 400}>
                  <LineChart
                    data={results.timeline.filter((_, i) => i % Math.ceil(results.timeline.length / 100) === 0)}
                    margin={isMobile ? { top: 5, right: 10, left: 0, bottom: 5 } : { top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" stroke="#E5E5E5" />
                    <XAxis
                      dataKey="date"
                      stroke="#AFAFAF"
                      style={{ fontSize: isMobile ? '10px' : '12px', fontWeight: '700' }}
                      tickFormatter={(value) => {
                        const date = new Date(value);
                        return date.toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
                      }}
                    />
                    <YAxis
                      stroke="#AFAFAF"
                      style={{ fontSize: isMobile ? '10px' : '12px', fontWeight: '700' }}
                      tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
                    />
                    <Tooltip
                      contentStyle={{
                        background: '#fff',
                        border: '3px solid #E5E5E5',
                        borderRadius: '16px',
                        padding: '12px 16px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                      }}
                      labelStyle={{ color: '#4B4B4B', fontWeight: '800', marginBottom: '8px' }}
                      itemStyle={{ color: '#4B4B4B', fontWeight: '700' }}
                      formatter={(value) => `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    />
                    <Legend
                      wrapperStyle={{ paddingTop: '20px', fontWeight: '700' }}
                      iconType="line"
                    />
                    <Line
                      type="monotone"
                      dataKey="invested"
                      stroke="#AFAFAF"
                      strokeWidth={4}
                      dot={false}
                      name="💸 Total Invested"
                    />
                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke={results.roi >= 0 ? "#58CC02" : "#FF4B4B"}
                      strokeWidth={5}
                      dot={false}
                      name="💎 Portfolio Value"
                    />
                  </LineChart>
                </ResponsiveContainer>
              )}
            </div>
          </>
        )}

        {/* Fun Footer */}
        <div style={{
          marginTop: isMobile ? '32px' : '48px',
          textAlign: 'center',
          background: '#fff',
          padding: isMobile ? '24px 20px' : '32px',
          borderRadius: isMobile ? '20px' : '24px',
          boxShadow: '0 8px 0 rgba(0, 0, 0, 0.1)',
          border: '4px solid #fff'
        }}>
          <p style={{
            fontSize: isMobile ? '16px' : '18px',
            color: '#4B4B4B',
            fontWeight: '800',
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            flexWrap: 'wrap'
          }}>
            <span>📚</span>
            <span>This is a fun learning tool!</span>
          </p>
          <p style={{
            fontSize: isMobile ? '13px' : '14px',
            color: '#AFAFAF',
            fontWeight: '700',
            margin: 0
          }}>
            Historical data is simulated for demonstration purposes.
          </p>

          <p style={{
            fontSize: isMobile ? '12px' : '13px',
            color: '#AFAFAF',
            fontWeight: '800',
            marginTop: '12px',
            marginBottom: 0,
            lineHeight: 1.6
          }}>
            Vibe-coded by{' '}
            <a
              href="https://x.com/0xjulian_"
              target="_blank"
              rel="noreferrer"
              style={{
                color: '#4B4B4B',
                textDecoration: 'none',
                borderBottom: '2px solid rgba(0,0,0,0.12)',
                paddingBottom: '2px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              {/* X (Twitter) icon */}
              <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" style={{ display: 'block' }}>
                <path
                  fill="currentColor"
                  d="M18.901 1.153h3.68l-8.04 9.19 9.46 12.504h-7.4l-5.79-7.57-6.62 7.57H.5l8.6-9.84L0 1.153h7.59l5.23 6.92 6.08-6.92Zm-1.29 19.49h2.04L6.48 3.24H4.29l13.32 17.4Z"
                />
              </svg>
              0xJulian
            </a>
            . Send me feedback — or{' '}
            <span style={{ whiteSpace: 'nowrap' }}>🔁 share</span> it if you{' '}
            <span style={{ whiteSpace: 'nowrap' }}>❤️ love</span> it.
          </p>

        </div>
      </div>
    </div >
  );
};

export default WhatIfInvested;